import { observable, action, autorun } from 'mobx';

class PanelStore {
  @observable panelStatus;
  constructor() {
    this.panelStatus = {
      isToggleOn: false,
      isResizeOn: false
    };
  }
  @action togglePanel = () => {
    this.panelStatus.isToggleOn = !this.panelStatus.isToggleOn;
  }
  @action toggleResizePanel = () => {
    this.panelStatus.isResizeOn = !this.panelStatus.isResizeOn;
  }
}

const panelStore = new PanelStore();
export default panelStore;
export { PanelStore };



// WEBPACK FOOTER //
// ./src/stores/panelStore/index.js